<template>
  <template v-if="data.lkp_art_id==1 || data.lkp_art_id==3 || data.lkp_art_id==2 || data.lkp_art_id==4 || data.lkp_art_id==5 || data.lkp_art_id==6">
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
      <div class="mb3 text-left">
         <span class="no_permohonan">{{data.no_permohonan}}</span> | 
          <template v-if="data.lkp_status_id == 33 || data.lkp_status_id == 21 ">
            <w-tag class="mr4" bg-color="error" round>{{data.status_keterangan}}</w-tag><span class="catatan">({{ data.catatan }})</span>
          </template>
          <template v-else>
            <w-tag class="mr4" bg-color="primary" round> {{data.status_keterangan}} </w-tag>
          </template>
      </div>
    <z-page title="Senarai Permohonan Perkhidmatan Teknologi Pembiakan" >
      <div class="table_scrol">
        <table class="w-table" color="light" >
          <tbody><tr><td>
          <w-card bg-color="" class="">
            <w-form class="" v-model="data.valid" v-model:errors-count="data.errorsCount" @validate="onValidate" @success="onSuccess">
              <div class="w-flex wrap smd-column" >
              <div class="grow xs4" style="line-height: 15px">
               <table>
                <tbody>
                  <tr class="row_data">
                     <td><b>ID Premis</b></td>
                     <td><b>:</b></td>
                     <td>{{data.no_premis}}</td>
                  </tr>

                  <tr class="row_data">
                     <td><b>Tarikh Mohon</b></td>
                     <td><b>:</b></td>
                     <td>{{$zutil.dateformat(data.tarikh_mohon)}} / {{$zutil.formatDateToTime(data.tarikh_mohon)}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="grow xs4" style="line-height: 15px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>Nama Premis</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_premis}}</td>
                  </tr>
                  <tr class="row_data" v-if="data.lkp_art_id==1">
                     <td><b>Tarikh Pengesanan Berahi</b></td>
                     <td><b>:</b></td>
                     <td>{{$zutil.dateformat(data.tarikh_pengesanan_biang)}} / {{$zutil.formatMasa(data.masa_pengesanan_biang)}}</td>
                  </tr>
                  <tr class="row_data" v-if="data.lkp_art_id==2">
                     <td><b>Tujuan PD</b></td>
                     <td><b>:</b></td>
                     <td>{{data.lkp_tujuan}}</td>
                  </tr>
                  <tr class="row_data" v-if="data.lkp_art_id==5 || data.lkp_art_id==6 ">
                     <td><b>Tarikh Temujanji</b></td>
                     <td><b>:</b></td>
                     <td>{{data.tarikh_temujanji}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="grow xs4" style="line-height: 15px">
               
                  
                  <!-- <template v-if="$zutil.anyRole(['4'])">
                  <tr class="row_data" v-if="data.lkp_art_id==5 || data.lkp_art_id==6 ">
                     <td><b>Nama Penternak</b></td>
                     <td><b>:</b></td>
                     <td>{{data.user_nama}}</td>
                  </tr>
               </template> -->

                  <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                    <tr class="row_data">
                      <td style="width: 150px; vertical-align: top;"><b>Pasung</b></td>
                      <td style="width: 10px; vertical-align: top;"><b>:</b></td>
                      <td>
                        <div v-if="data.pasung==1">Ada</div>
                        <div v-else>Tidak Ada</div>
                      </td>
                    </tr>

                    <tr class="row_data" v-if="data.lkp_art_id==1 || data.lkp_art_id==2 || data.lkp_art_id==3 || data.lkp_art_id==4" >
                     <td><b>Nama Pemeriksa</b></td>
                     <td><b>:</b></td>
                     <td>{{data.user}}</td>
                  </tr>

                    <tr class="row_data" v-if="data.lkp_art_id==5 || data.lkp_art_id==6">
                      <td style="width: 150px; vertical-align: top;"><b>Nama Pemeriksa</b></td>
                      <td style="width: 10px; vertical-align: top;"><b>:</b></td>
                      <td>
                        <ol style="margin: 0; padding-left: 20px;">
                          <li v-for="(user, index) in data.user.split(', ')" :key="index">
                            {{ user }}
                          </li>
                        </ol>
                      </td>
                    </tr>
                    </tbody>
                  </table>


                 
              </div>
            </div>
            </w-form>
          </w-card>
          </td></tr></tbody>
        </table>
        <br>

        <template v-if="data.lkp_art_id==1">
           <AiShow :d_id="id"/>
        </template>
        <template v-if="data.lkp_art_id==4">
           <SinkronisasiShow :d_id="id"/>
        </template>
        <template v-if="data.lkp_art_id==3">
          <EtShow :d_id="id"/>
        </template>
         <template v-if="data.lkp_art_id==2">
          <PdShow :d_id="id"/>
        </template>
        <template v-if="data.lkp_art_id==5">
          <BseShow :d_id="id"/>
        </template>
        <template v-if  = "data.lkp_art_id==6">
        <FeShow   :d_id = "id"/>
        </template>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </div>
    </z-page>
  </zen-one>

  </template>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource';
import AiShow from './AiShow.vue';
import SinkronisasiShow from './SinkronisasiShow.vue';
import EtShow from './EtShow.vue';
import PdShow from './PdShow.vue';
import BseShow from './BseShow.vue';
import FeShow from './FeShow.vue';
import VueQrcode from 'vue-qrcode'

export default {
  extends: ZResource,
  components: {
    VueQrcode, AiShow, SinkronisasiShow, EtShow, PdShow, BseShow, FeShow,
  },
  props: {
    id: [Array, Object, String],

  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pembiakan Permohonan', route: '/art' },
        { label: 'Permohonan', route: '/art/permohonan' },
        { label: 'Papar', route: '/art/permohonan/'+this.id },
      ],

      title : '',
      data : {id : 0},
      activeTab : 0,
      ternakan_list:[],
      tabs: [
            { title: 'RUMUSAN PERKHIDMATAN', content: '' },
            { title: 'BUTIRAN KELAHIRAN', content: ''},
            { title: 'AUDIT TRAIL', content: ''},

          ]
    }
  },
  methods: {

    tutup(){
         this.$inertia.visit(window.route('art.semakan.index'));
       },

    cetak(data){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('art.permohonan.cetak', data), '_blank');
    },

    sahkan(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(this.data.id > 0){
            this.data.lkp_status_id = item;
            this.data.peternak = 1;
          this.$zcomm.update('art.ai.update', this.data.id, this.data)
              .then(res => {
                console.log(res);
                  this.dialog.show = false;
                  this.$inertia.reload();
              })
              .catch(err => {

              })
              .finally(() => {

                this.$inertia.visit(this.$page.url)
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;}

        })
      },



    getData()
    {
      this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
        this.data = res
        // if (this.data) {}
      // if(this.$zutil.role('1')){
      //     this.tabs = [
      //       // { title: 'Baka', content: '' },
      //       { title: 'Ternakan', content: '' },

      //     ]
      //   }
      //   else
      //   {
      //     this.tabs = [
      //       { title: 'Ternakan', content: '' },

      //     ]
      //   }
         if(this.data.lkp_status_id==18){
            this.tabs[1].disabled = false;
         }else{
            this.tabs[1].disabled = true;
         }
       if(this.data.lkp_art_id == 1)
        {
          this.title = 'RUMUSAN PERKHIDMATAN AI'
        }
        if(this.data.lkp_art_id == 2)
        {
          this.title = 'RUMUSAN PEMERIKSAAN KEBUNTINGAN'
        }
        if(this.data.lkp_art_id == 3)
        {
          this.title = 'RUMUSAN PERKHIDMATAN ET'
        }
        this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
      if(this.params.t == 2){
        this.activeTab = 1
      }

      })
    },




  },
  watch: {

  },
  mounted() {
    this.getData();


  },
}
</script>

<style>
.no_permohonan {
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
}
.catatan {
    font-size: 15px;
    line-height: 30px;
}
table{
  width: 100%;
}
</style>
